import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

/** Step 2 — Business description only.
 *  The personal/owner bio was moved to Edit Profile so signups stay fast.
 */
// eslint-disable-next-line no-unused-vars
export default function Step2Profile({ description, setDescription, bio, setBio }) {
  return (
    <div className="space-y-6">
      <div>
        <Label className="text-stone-300 font-outfit">About Your Business *</Label>
        <Textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Tell potential customers about your business, your story, and what makes you unique..."
          className="input-field w-full mt-2 min-h-[150px]"
          data-testid="business-description"
        />
        <p className="text-stone-500 text-xs mt-1 font-outfit">
          Write one line or a full paragraph — you can refine it anytime from Edit Profile. A personal bio is optional and lives under Edit Profile too.
        </p>
      </div>
    </div>
  );
}
